var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as SavvyResultsUI from "../SavvyResultsUI/SavvyResultsUI";
import { getCleanId, getLogoFileName } from "../../utils/getLogoV3ImgSrc";
import { getLeaveBehindSearchResults, useLazyGetLeaveBehindSearchResultsQuery, } from "../../services/savvy";
import { FeatureFlagVersions } from "../../features/feature-flags/featureFlagsSlice";
import { ImpressionType } from "../../lib/constants";
import { SellingPointGroups } from "../../features/search/components/SellingPoints";
import { addClickedResult } from "../../features/search/searchSlice";
import { clickedBuyQuoteButton } from "../../lib/Avo";
import { findSavvyAdvertiser } from "../../utils/findSavvyAdvertiser";
import handleResultClick from "../../utils/handleResultClick";
import { shouldOpenInSameWindow } from "../../lib/util";
import { skipToken } from "@reduxjs/toolkit/query";
import useAffiliateConfig from "../../hooks/useAffiliateConfig";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import useEventPublisher from "../../hooks/useEventPublisher";
import useFindIssuer from "../../features/configuration/useFindIssuer";
function getAdIssuerId(advertiserName, issuerId) {
    if (advertiserName) {
        var advertiserLogo = getLogoFileName(advertiserName);
        if (advertiserLogo) {
            return advertiserName;
        }
    }
    if (issuerId) {
        var issuerLogo = getLogoFileName(issuerId);
        if (issuerLogo) {
            return issuerId;
        }
    }
}
export default function Ad(_a) {
    var ad = _a.ad, index = _a.index, impressionId = _a.impressionId, className = _a.className, insuranceType = _a.insuranceType, _b = _a.badgeText, badgeText = _b === void 0 ? "Top Offer" : _b, _c = _a.variant, variant = _c === void 0 ? "default" : _c, _d = _a.impressionType, impressionType = _d === void 0 ? ImpressionType.AfterClick : _d;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var eventPublisher = useEventPublisher();
    var findIssuer = useFindIssuer();
    var topOfferBadge = useAffiliateConfig().topOfferBadge;
    var accountReferenceId = useAppSelector(function (state) { return state.applicant.accountReferenceId; });
    var dispatch = useAppDispatch();
    var runLeaveBehindSearch = useLazyGetLeaveBehindSearchResultsQuery()[0];
    var isLeaveBehindSearchSuccess = getLeaveBehindSearchResults.useQueryState(accountReferenceId
        ? {
            accountReferenceId: accountReferenceId,
            impressionType: ImpressionType.AfterClick,
        }
        : skipToken).isSuccess;
    var leaveBehindSearchVersion = useAppSelector(function (state) { return state.featureFlags.flags.recommend_leaveBehindSearch_frontend; });
    var hasClickedAd = useAppSelector(function (state) {
        return ad.id ? state.search.clickedResults.includes(ad.id) : false;
    });
    var leaveBehindSearchEnabled = [
        FeatureFlagVersions.V2,
        FeatureFlagVersions.V3,
        FeatureFlagVersions.V4,
        FeatureFlagVersions.GateV2,
        FeatureFlagVersions.GateV3,
        FeatureFlagVersions.GateV4,
    ].includes(leaveBehindSearchVersion);
    var clickUrl = ad.clickUrl, advertiserName = ad.advertiserName, issuerId = ad.issuerId, altText = ad.altText;
    var adIssuerId = getAdIssuerId(advertiserName, issuerId);
    var adIssuer = findIssuer(adIssuerId || "", { exact: true }) ||
        findSavvyAdvertiser(advertiserName || "") || {
        id: getCleanId(adIssuerId !== null && adIssuerId !== void 0 ? adIssuerId : ""),
        name: advertiserName,
    };
    var isDisabled = hasClickedAd && isLeaveBehindSearchSuccess;
    function handleClick(ev) {
        ev.preventDefault();
        if (hasClickedAd && leaveBehindSearchEnabled) {
            return;
        }
        var openInSameWindow = shouldOpenInSameWindow();
        if (ad.id) {
            dispatch(addClickedResult(ad.id));
        }
        clickedBuyQuoteButton(__assign(__assign({}, commonAnalyticsProperties), { impressionType: impressionType, 
            // the result list index is 1 based, and we pass 0-based indexes from arrays
            resultListPosition: index + 1, openInNewWindow: !openInSameWindow }));
        eventPublisher.clickOffer(ad, impressionId);
        if (leaveBehindSearchEnabled &&
            accountReferenceId &&
            !isLeaveBehindSearchSuccess) {
            setTimeout(function () {
                runLeaveBehindSearch({
                    accountReferenceId: accountReferenceId,
                    impressionType: ImpressionType.AfterClick,
                });
            }, 1000);
        }
        if (clickUrl) {
            handleResultClick(clickUrl, openInSameWindow);
        }
    }
    return (React.createElement(SavvyResultsUI.Card, { anchorProps: __assign(__assign({ href: clickUrl, onClick: handleClick, title: altText || advertiserName }, { "data-testid": "savvy-ad" }), { className: className }), issuerId: adIssuer.id, name: advertiserName || "", clickText: ad.clickText, altText: altText, badge: index === 0 && topOfferBadge && !isDisabled ? (React.createElement(SavvyResultsUI.Badge, { className: "rounded-none rounded-bl-lg px-2 pb-1 pt-1.5", variant: "green" }, badgeText)) : undefined, bottomContent: ad.sellingPointGroups && ad.sellingPointGroups.length > 0 ? (React.createElement(SellingPointGroups, { groups: ad.sellingPointGroups })) : null, variant: variant, insuranceType: insuranceType, disabled: isDisabled }));
}
